import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Form, Descriptions, Card, Col, Spin, message } from 'antd';
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { fetchCaseEnachMandataDetails, fetchCaseEnachMandateStatus } from "store/actions";
import { STATE_STATUS } from "constants";
import { splitAndCapitalize, getKeyByValueImmutableMap } from '../../components/helper';
import { List, Map } from 'immutable';

import { CaseService } from '../../services';
import NachMandateForm from '../../forms/nach-mandate-form';
import NachDetailsDrawer from '../../components/nach-details-drawer';
import { BANK_ACCOUNT_TYPES, NACH_STATUS } from '../../constants/enums';


class NachMandate extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        visible: false,
        triggerDetails: {},
        triggerNachLoader: false,
        formValues: {}
    }
    componentDidMount() {
        //Nach Status GET API
        this.props.fetchCaseEnachMandateStatus(this.props.caseId);
    }
    componentDidUpdate(prevProps) {
        //After Nach Detail API success Show Nach Detail Drawer
        if (prevProps.nachData.get("status") == STATE_STATUS.FETCHING && this.props.nachData.get("status") == STATE_STATUS.FETCHED) {
            this.setState({
                visible: true
            })
        }
    }
    // Close Nach Drawer
    onClose = () => {
        this.setState({
            visible: false,
            triggerDetails: {},
            formValues: {},
        })
    }

    onSubmit = (payload, formValues) => {
        this.setState({
            triggerDetails: payload,
            formValues: formValues
        })
        this.props.fetchCaseEnachMandataDetails(this.props.caseId, payload);
    }

    getBankColums(bank_details) {
        return Map({
            account_number: bank_details["account_number"],
            account_holder_name: bank_details["account_holder_name"],
            account_type: BANK_ACCOUNT_TYPES.findKey(val => val === bank_details["account_type"]),
            account_limit: bank_details["account_limit"],
            ifsc: bank_details['bank_branch']['ifsc_code'],
            bank_name: bank_details['bank_branch']['bank_name'],
            bank_branch: bank_details['bank_branch']['address']
        })
    }

    // Get Bank Detail View for user
    getBankDetails = () => {
        const { nachMandateStatusResponse } = this.props;
        if (!nachMandateStatusResponse || !nachMandateStatusResponse.get("status")) {
            return <></>
        }
        return <Card
            className={"padless-card bank-account-list-card"}
            title={"Bank Accounts"}
        >
            {nachMandateStatusResponse.get("status") == STATE_STATUS.FETCH_FAILED ?
                <div>
                    Something Went Wrong
                </div> :
                <Descriptions bordered column={1}>
                    {[STATE_STATUS.FETCHING, STATE_STATUS.UNFETCHED].includes(nachMandateStatusResponse.get("status")) ?
                        <Spin loading={true}></Spin> :
                        this.getBankColums(nachMandateStatusResponse.get('bank_account')).map((_, key) => (
                            <Descriptions.Item
                                key={key}
                                label={splitAndCapitalize('_', key)}
                            >
                                {_}
                            </Descriptions.Item>
                        ))
                    }
                </Descriptions>}
        </Card>
    }

    // Final Trigger Nach Mandate
    triggerEnach = (payload = {}, formValues = {}) => {
        const { nachMandateStatusResponse } = this.props;
        var today = new Date();
        var year = today.getFullYear();
        var month = String(today.getMonth() + 1).padStart(2, '0'); // Add 1 since months are zero-based
        var day = String(today.getDate()).padStart(2, '0');
        const bank_details = nachMandateStatusResponse.get('bank_account');
        const data = {
            "associate": this.state.triggerDetails.associate_id || payload.associate_id,
            "account": bank_details['account_number'],
            "collection_date": `${year}-${month}-${day}`, // Passing current nach creation date 
            "nach_type": this.state.triggerDetails.mandate_type || payload.mandate_type,
            "amount": 10000000, // 1 cr default nach amount as per RBI
            "emi_date": this.state.triggerDetails['emi_date'] || payload.emi_date
        }
        this.setState({
            triggerNachLoader: true,
            formValues: formValues
        })
        //Call Nach Trigger API
        CaseService.triggerEnach(this.props.caseId, data)
            .then((resp) => {
                this.props.fetchCaseEnachMandateStatus(this.props.caseId);
                this.setState({
                    triggerNachLoader: false,
                    formValues: {},
                    triggerDetails: {}
                })
                message.success("Nach Created Successfully");
                this.setState({
                    visible: false
                })
            })
            .catch((err) => {
                this.setState({
                    triggerNachLoader: false,
                    formValues: {},
                    triggerDetails: {}
                })
                message.error("Something went wrong!")
            })
    }
    render() {
        const { nachData, caseId, nachMandateStatusResponse } = this.props;
        const { triggerDetails } = this.state;
        const mandateType = nachMandateStatusResponse.get('nach_details') && nachMandateStatusResponse.get('nach_details').mandate_type;
        return (
            <React.Fragment>
                <Row>
                    <Col span="24">
                        {this.getBankDetails()}
                    </Col></Row>
                <Spin spinning={nachMandateStatusResponse && this.state.visible && nachMandateStatusResponse.get("status") == STATE_STATUS.FETCHING}>
                    {this.state.visible && nachMandateStatusResponse && nachMandateStatusResponse.get('status') == STATE_STATUS.FETCHED && <NachDetailsDrawer
                        triggerNachLoader={this.state.triggerNachLoader}
                        visible={this.state.visible}
                        nachData={nachData}
                        nachStatusResponse={this.props.nachMandateStatusResponse && this.state.triggerDetails != null && this.props.nachMandateStatusResponse.get('data').filter(_ => _.getEmiDate() == this.state.triggerDetails['emi_date'])[0]}
                        onClose={this.onClose}
                        triggerEnach={this.triggerEnach}
                    />}
                    {nachMandateStatusResponse.get('status') == STATE_STATUS.FETCHED && nachMandateStatusResponse.get('emi_dates').map((__, index) => {
                        const nach_detail = nachMandateStatusResponse.get('data').filter(_ => _.getIn(['nach_details', 'emi_date']) == __)[0];
                        return <Row className={"p-5"}>
                            <Card><Row>
                                {console.log("in nach mamss", nach_detail)}


                                {console.log('in mappp', _, nachMandateStatusResponse.get('data').filter(_ => _.getIn(['nach_details', 'emi_date']) == __))}
                                <Col span="12">
                                    {nachMandateStatusResponse.get('status') == STATE_STATUS.FETCHED ? <NachMandateForm
                                        caseId={caseId}
                                        bank_account={nachMandateStatusResponse.get('bank_account')}
                                        loading={_ == nachMandateStatusResponse.getIn(['data', index, 'nach_details', 'emi_date']) && this.props.nachData.get("status") == STATE_STATUS.FETCHING}
                                        schemeType={this.props.schemeType}
                                        caseAssociates={this.props.caseAssociates}
                                        onSubmit={(this.onSubmit)}
                                        currentEmiDate={__}
                                        nachMandateStatusResponse={nach_detail ? nachMandateStatusResponse.get('data').filter(_ => _.getIn(['nach_details', 'emi_date']) == __)[0] : Map()}
                                        values={Object.keys(this.state.formValues).length ? Map(this.state.formValues) : nach_detail ? Map(nach_detail.get('nach_details')) : null}
                                        nachStatus={this.props.nachData.get("status")}
                                        triggerEnach={this.triggerEnach}
                                        updateNachData={() => this.props.fetchCaseEnachMandateStatus(this.props.caseId)}
                                        currentCaseTaskStageId={this.props.currentCaseTaskStageId}
                                        user={this.props.user}
                                    /> : <></>}
                                </Col>
                                <Col span={2}></Col>
                                {/* Bank Details  */}
                            </Row>
                                <Row className='mb-10 mt-10'>
                                    {/* Nach Status */}
                                    <Col span={24}>
                                        {(nach_detail && nach_detail.getIn(['nach_details', 'mandate_type']) != 3 && nachMandateStatusResponse.get('status') == STATE_STATUS.FETCHED) ? <Card>
                                            <Descriptions bordered size={2}>
                                                <Descriptions.Item label="Mandate">{nach_detail.getIn(['nach_details', 'mandate_id'], '-')}</Descriptions.Item>
                                                <Descriptions.Item label="Mode">{nach_detail.getMandateTypeLabel()}</Descriptions.Item>
                                                <Descriptions.Item label="Transferred to">{nach_detail.getTransferredTo() || '-'}</Descriptions.Item>
                                                <Descriptions.Item label="UMRN">{nach_detail.getIn(['nach_details', 'umrn']) || '-'}</Descriptions.Item>
                                                <Descriptions.Item label="Status">{getKeyByValueImmutableMap(NACH_STATUS, nach_detail.getIn(['nach_details', 'nach_status']))}</Descriptions.Item>
                                            </Descriptions>
                                        </Card> : <></>}
                                    </Col>
                                </Row>
                            </Card>
                        </Row>
                    }
                    )}
                </Spin>

            </React.Fragment>
        )
    }
}
NachMandate.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,

};

const mapStateToProps = (state, props) => {
    return {
        nachData: state.caseDetails.getIn([Number(props.caseId), "nachMandate"]),
        nachMandateStatusResponse: state.caseDetails.getIn([Number(props.caseId), "nachStatusResponse"], List()),
        caseAssociates: state.caseDetails.getIn([props.caseId, "caseAssociates", "data"]),
        currentCaseTaskStageId: state.caseDetails.getIn([Number(props.caseId), "data", 'current_case_task']),
        user: state.user.get("data"),
    };
};

const WrappedNachMandate = Form.create({
    mapPropsToFields: ({ values }) => {
        return (
            values &&
            values
                .toSeq()
                .toMap()
                .map((value, key) => {
                    return Form.createFormField({
                        value
                    });
                })
                .toJS()
        );
    }
})(NachMandate);


export default connect(
    mapStateToProps,
    dispatch =>
        bindActionCreators(
            {
                fetchCaseEnachMandataDetails,
                fetchCaseEnachMandateStatus
            },
            dispatch
        )
)(WrappedNachMandate);

